var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b{fill:#c8d1ec;}.c,.e{fill:none;}.c{stroke:#c8d1ec;stroke-width:1.5px;}.d{stroke:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74,
    height: 74,
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.562 26.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.209,111.431l-1.6-3.466a7.011,7.011,0,0,1,2.033-.3,6.205,6.205,0,0,1,.854.055v-3.47a1.739,1.739,0,0,0-1.813-1.7H26.549l-.036-2.957a.917.917,0,0,0-1.076-.891l-.357.063L21.5,99.4a.917.917,0,1,0,.319,1.805l2.878-.508.021,1.734a6.931,6.931,0,0,0-3.832,1.6c-2.473,2.112-1.582,3.05-6.063,3.05-1.884,0-4.261-2.714-6.635-3.063a10.442,10.442,0,0,0-4.786.363,5.291,5.291,0,0,0-.78.345,2.093,2.093,0,0,0-1.285,1.763c0,1.121,1.041,1.963,2.436,2.589a7.144,7.144,0,0,1,6.3-1.111l-1.59,3.469,1.686.721,1.579-3.445a7.166,7.166,0,0,1,3.446,6.1H22.5a7.166,7.166,0,0,1,3.437-6.1l1.584,3.443A15.861,15.861,0,0,0,29.209,111.431Zm-20.728,0-.85,1.855-.461,1.006a.917.917,0,1,0,1.667.764l.513-1.12.818-1.784Zm19.042.724.82,1.783.515,1.119a.917.917,0,0,0,1.666-.766l-.462-1-.853-1.854C29.358,111.411,27.523,112.154,27.523,112.154Z",
    transform: "translate(-1.332 -98.687)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(22.283 9.723)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 6.077,
    cy: 6.077,
    rx: 6.077,
    ry: 6.077
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 6.077,
    cy: 6.077,
    rx: 5.327,
    ry: 5.327
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0.405 9.723)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 6.077,
    cy: 6.077,
    rx: 6.077,
    ry: 6.077
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 6.077,
    cy: 6.077,
    rx: 5.327,
    ry: 5.327
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoto);
export default __webpack_public_path__ + "static/media/moto.76190cab13a0ff091b7ef7718d003451.svg";
export { ForwardRef as ReactComponent };